import {defineStore} from "pinia";
import {createBaseStore} from "@/stores/base";

export const useEmailTemplateStore = defineStore('emailTemplate', createBaseStore(
    '/email_templates/',
    {
        currentSort: [
            {col: 'name', sortDir: 'asc'}
        ]
    },
    {},
    {}
))
